import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import {
  getspecificSingleProductbyname,
} from "../../../actions/singleProductAction";
import { createVariableProduct } from "../../../actions/variableProductAction";
import { getAllCategory } from "../../../actions/categoryAction";
import { getAllContactMerchandiser } from "../../../actions/contactAction";
import { getAllWarehouse, getOnlyWarehouse } from "../../../actions/warehouseAction";
import { getAllAttribute } from "../../../actions/attributeAction";
import PicturesWall from "../ProductDetails/PictureWall";
import ImageUpload from "../ProductDetails/ImageUpload";
import {
  Form,
  Input,
  InputNumber,
  Checkbox,
  Button,
  Col,
  Row,
  Select,
  message,
  TreeSelect,
  Divider,
  Space,
  Spin,
} from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

const { Option } = Select;

const CreateNewContact = ({
  getAllAttribute,
  setUpdatelist,
  List,
  getAllCategory,
  getAllContactMerchandiser,
  Merchandiser,
  getAllWarehouse,
  getOnlyWarehouse,
  Warehouse,
  createVariableProduct,
  Attribute,
  updatelist,
  getspecificSingleProductbyname,
}) => {
  const [form] = Form.useForm();
  const [cover, setcover] = useState([]);
  const [loading, setloading] = useState(false);
  const sPrice = useRef(0);
  const [reload, setreload] = useState(false);
  const [Showresults, setShowresults] = useState([]);
  const counter = useRef(0);
  const location = useRef("");
  // Mufrid
  const handleProductNameSearch = (event) => {
    if (event.target.value != "") {
      // setShowresults(true);
      // setkeyword(value);
      counter.current = 0;
      const intervalId = setInterval(function () {
        counter.current++;
      }, 1000);

      setTimeout(function () {
        // console.log("at the timout : " + counter.current);
        if (counter.current > 8) {
          getspecificSingleProductbyname(event.target.value).then(
            (product) => {
              if (product.count > 0) {
                message.warning("Product SKU " + event.target.value + " already exists");
                setloading(false);
              }
            });
          // console.log("at the end : " + counter.current);
          counter.current = 0;
          clearInterval(intervalId);
          setreload(!reload);
        }
      }, 2000);
    } else {
      setShowresults(false);
    }
  };

  const onFinish = (values) => {
    setloading(true);
    if (typeof values["is_active"] == "undefined") {
      values["is_active"] = false;
    }

    if (values.Variations.length > 0) {
      values.Variations.forEach((element) => {
        const keys = Object.keys(element);
        const attributes = [];
        keys.forEach((key, index) => {
          console.log(`${key}: ${element[key]}`);
          if (
            key !== "Warehouse" &&
            key !== "purchase_price" &&
            key !== "selling_price" &&
            key !== "quantity" &&
            typeof element[key] != "undefined"
          ) {
            attributes.push(element[key]);
            console.log("working");
          }
        });
        element["Attributes"] = attributes;
      });
    }

    // console.log(values.Variations)
    // createVariableProduct(values).then((e) => {
    //   console.log(e);
    //   setUpdatelist(false);
    //   // window.location.href = e;
    // });


    createVariableProduct(values).then((e) => {
      setTimeout(
        function () {
          setloading(false);
          setUpdatelist(false);
        }.bind(this),
        3000
      );
    });
  };
  const uploadcover = (fileList) => {
    setcover(fileList);
  };

  useEffect(() => {
    getAllCategory();
    getAllContactMerchandiser();
    getAllAttribute();
    // getAllWarehouse();
    getOnlyWarehouse();
  }, [
    getAllCategory,
    getAllContactMerchandiser,
    // getAllWarehouse,
    getOnlyWarehouse,
    setUpdatelist,
  ]);

  const [discountType, setDiscountType] = useState("%");
  const [discount, setDiscount] = useState(0);
  const [purchasePrice, setPurchasePrice] = useState(0);
  // const [sellingPrice, setSellingPrice] = useState(0);
  const [sellingPrice, setSellingPrice] = useState(0);
  const [productDiscountType, setProductDiscountType] = useState("%");
  const [productDiscount, setProductDiscount] = useState(0);
  const [productDiscountPrice, setProductDiscountPrice] = useState(0);

  const calculateSellingPrice = () => {
    let calculatedSellingPrice = 0;
    if (discountType === "%" && purchasePrice !== null && discount !== null) {
      const discountAmount = (purchasePrice * discount) / 100;
      calculatedSellingPrice = parseFloat(purchasePrice) + parseFloat(discountAmount);
    } else if (discountType === "$" && discount !== null) {
      calculatedSellingPrice = parseFloat(purchasePrice) + parseFloat(discount);
    }
    return calculatedSellingPrice;
  };

      // Function to calculate the product discount price based on the product discount type and amount
      const calculateProductDiscountPrice = () => {
        let calculatedProductDiscountPrice = 0;
        if (productDiscountType === "%" && sellingPrice !== null && productDiscount !== null) {
          const productDiscountAmount = (sellingPrice * productDiscount) / 100;
          calculatedProductDiscountPrice = parseFloat(sellingPrice) - parseFloat(productDiscountAmount);
        } else if (productDiscountType === "$" && productDiscount !== null) {
          calculatedProductDiscountPrice = parseFloat(sellingPrice) - parseFloat(productDiscount);
        }
        return calculatedProductDiscountPrice;
      };
  
    // const calculateDiscountProductPrice = () => {
    //   let calculatedDiscountProductPrice = 0;
    //   if (productDiscountType === "%" 
    //     && productDiscountPrice !== null 
    //     && productDiscount !== null) 
    //     {
    //     const productDiscountAmount = (productDiscountPrice * productDiscount) / 100;
    //     calculatedDiscountProductPrice = parseFloat(purchasePrice) + parseFloat(productDiscountAmount);
    //   } else if (discountType === "$" && discount !== null) {
    //     calculatedDiscountProductPrice = parseFloat(purchasePrice) + parseFloat(discount);
    //   }
    //   return calculatedDiscountProductPrice;
    // };

  //     setSellingPrice(calculatedSellingPrice);
  //     console.log(sellingPrice)
  //     sPrice.current = calculatedSellingPrice;
  //     // form.setFieldsValue("selling_price",calculatedSellingPrice)  
  // }, [discountType, discount, purchasePrice]);

  useEffect(() => {
    form.setFieldsValue({ selling_price: calculateSellingPrice() });
  }, [discountType, discount, purchasePrice, form]);

  useEffect(() => {
    form.setFieldsValue({ product_discount_price: calculateProductDiscountPrice() });
    // setProductDiscountPrice(calculateProductDiscountPrice());
  }, [sellingPrice, productDiscount, productDiscountType, form]);


  const loadattributes = (name, fieldKey, restField) => {
    return Attribute.map((attribute) => {
      if (attribute.name === "Size") {
        return <>
          <Col span={6}>
            <Form.Item
              label={attribute.name}
              {...restField}
              name={[name, attribute.name]}
              fieldKey={[fieldKey, "key"]}
            >
              <Select
                // showSearch
                // mode="multiple"
                // allowClear
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              // onClick={(event) => { console.log(event.target.values) }}
              >
                {attribute.terms.map((item) => {
                  return <Option value={item.id}>{item.name}</Option>;
                })}
              </Select>
            </Form.Item>
          </Col>

        </>
      } else {
        return <>
          <Col span={6}>
            <Form.Item
              label={attribute.name}
              {...restField}
              name={[name, attribute.name]}
              fieldKey={[fieldKey, "key"]}
            >
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {attribute.terms.map((item) => {
                  return <Option value={item.id}>{item.name}</Option>;
                })}
              </Select>
            </Form.Item>
          </Col>
        </>
      }
    });
  };

  return (
    <>
      <>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={{ discount_type: "%", purchase_price: "0" }}
        >
          <Row gutter={16}>
            {/* <PicturesWall setImages={uploadcover} limit={4} /> */}
            {/* <ImageUpload /> */}
            {/* <Col span={6}>
              <Form.Item
                name="title"
                label="Product Name"
                rules={[
                  { required: true, message: "Please enter product name" },
                ]}
              >
                <Input placeholder="New Product/12"
                  onChange={handleProductNameSearch} />
              </Form.Item>
            </Col> */}

            <Col span={4}>
              <Form.Item
                name="title"
                label="Product SKU"
                rules={[
                  { required: true, message: "Please enter Product SKU" },
                ]}
              >
                <Input placeholder="SKU/12"
                  onChange={handleProductNameSearch} />
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item
                name="product_code"
                label="Style Name"
                rules={[
                  { required: true, message: "Please enter Style Name" },
                ]}
              >
                <Input placeholder="Style Name" />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name="Category"
                label="Category"
                rules={[
                  {
                    required: true,
                    message: "please slect a category",
                  },
                ]}
              >
                <TreeSelect
                  showSearch
                  placeholder="Please select"
                  treeDefaultExpandAll
                  allowClear
                  treeNodeFilterProp="title"
                  treeData={List} 
                />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name="Merchandiser" label="Supplier">
                <Select
                  onChange={(value) => {
                    const merch = Merchandiser.find((o) => o.id === value);
                    console.log(merch);
                  }}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {(Array.isArray(Merchandiser) ? Merchandiser : []).map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item
                // name="Warehouse"
                name="Warehouse"
                label="Warehouse"
                rules={[
                  {
                    required: true,
                    message: "Please enter a warehouse",
                  },
                ]}>
                {/* <TreeSelect treeData={Warehouse} defaultOpen="Main Warehouse" /> */}
                <Select >
                  {Warehouse.map(warehouse => (
                    <Option value={warehouse.id}>{warehouse.name}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          {/* <Row gutter={16}> */}
            {/* <Col span={6}>
              <Form.Item
                name="product_code"
                label="Product Code"
                rules={[
                  { required: true, message: "Please enter product code" },
                ]}
              >
                <Input placeholder="product code" />
              </Form.Item>
            </Col> */}
            
            {/* <Col span={3}>
              <Form.Item name="stock_alart_amount" label="Stock Alert Amount">
                <InputNumber placeholder="Stock Alert Amount" />
              </Form.Item>
            </Col>

            <Col span={3}>
              <Form.Item name="stock_unit" label="Measurement Unit">
                <Input placeholder="Measurement Unit" />
              </Form.Item>
            </Col> */}
            

            {/* <Col span={6}>
              <Form.Item name="tax" label="VAT">
                <Input type="number" addonBefore="%" placeholder="VAT" />
              </Form.Item>
            </Col> */}
          {/* </Row> */}

          <Row gutter={16}>
            <Col span={6}>
              <Form.Item name="purchase_price" label="Purchase Price">
                <Input
                  addonBefore="BDT"
                  type="number"
                  // defaultValue={0}
                  placeholder="Purchase Price"
                  onChange={(e) => setPurchasePrice(e.target.value)}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              {/* <Form.Item name="discount_type" label="Discount Type">
                <InputNumber placeholder="Discount Type" />
              </Form.Item> */}
              <Form.Item label="Profit">
                <Input.Group compact>
                  <Form.Item name={"discount_type"} noStyle>
                    <Select onChange={(value) => setDiscountType(value)}>
                      <Option value="%">%</Option>
                      <Option value="$">BDT</Option>
                    </Select>
                  </Form.Item>
                  <Form.Item name={"discount"} noStyle>
                    <Input style={{ width: "70%" }} placeholder="Profit"
                      onChange={(e) => setDiscount(e.target.value)} />
                  </Form.Item>
                </Input.Group>
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item name="selling_price" label="Selling Price">
                <Input
                  addonBefore="BDT"
                  type="number"
                  placeholder="Selling Price"
                  initialValue={calculateSellingPrice()}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="Product Discount">
                <Input.Group compact>
                  <Form.Item name={"product_discount_type"} noStyle>
                    <Select defaultValue="%" onChange={(value) => setProductDiscountType(value)}>
                      <Option value="%">%</Option>
                      <Option value="$">BDT</Option>
                    </Select>
                  </Form.Item>
                  <Form.Item name={"product_discount"} noStyle>
                    <Input
                      style={{ width: "70%" }}
                      placeholder="Product Discount"
                      type="number"
                      onChange={(e) => setProductDiscount(parseFloat(e.target.value))}
                    />
                  </Form.Item>
                </Input.Group>
              </Form.Item>
            </Col>
          </Row>

          {/* <Row gutter={16}> */}
        
            {/* <Col span={6}>
              <Form.Item name="product_discount_price" label="Product Discount Price">
                <Input
                  addonBefore="BDT"
                  type="number"
                  placeholder="Product Discount Price"
                  initialValue={calculateProductDiscountPrice()}
                  // value={productDiscountPrice}
                  // readOnly
                />
              </Form.Item>
            </Col> */}
          {/* </Row> */}

          <Divider></Divider>
          <h3>Product Variations</h3>
          <div style={{ backgroundColor: "#f7f7f7ff", padding: "10px" }}>
            <Form.List name="Variations">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, fieldKey, ...restField }) => (
                    <Row wrap={false}>
                      {loadattributes(name, fieldKey, restField)}
                      <Col flex="auto">
                        <Form.Item
                          label="Initial Stock"
                          {...restField}
                          name={[name, "quantity"]}
                          fieldKey={[fieldKey, "quantity"]}
                          rules={[
                            {
                              required: true,
                              message: "Please enter a quantity",
                            },
                          ]}
                        >
                          <Input placeholder="Stock Amount" />
                        </Form.Item>
                      </Col>
                      <MinusCircleOutlined
                        onClick={() => remove(name)}
                        style={{ margin: "auto", color: "red", marginLeft: "3px" }}
                      />
                    </Row>
                  ))}
                  <Form.Item>
                    <Button
                      type="dashed"
                      onClick={(e) => add()}
                      block
                      icon={<PlusOutlined />}
                    >
                      Add field
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </div>

          <Divider></Divider>
          <Row gutter={16}>
            {/* <Col span={5}>
              <Form.Item name="height" label="Height">
                <Input type="number" placeholder="Height" addonAfter={"cm"} />
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item name="width" label="Width">
                <Input type="number" placeholder="Width" addonAfter={"cm"} />
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item name="weight" label="Weight">
                <Input
                  type="number"
                  placeholder="Weight"
                  addonAfter={"grams"}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item name="Short_description" label="Drescription">
                <Input.TextArea rows={4} placeholder="please enter Address" />
              </Form.Item>
            </Col> */}
            <Col span={24}>
              <Form.Item name="is_active" valuePropName="checked" initialValue={true}>
                <Checkbox>Active Product !</Checkbox>
              </Form.Item>
            </Col>
          </Row>
          <Spin spinning={loading}>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Submits
              </Button>
            </Form.Item>
          </Spin>
        </Form>
      </>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    List: state.category.categorylist,
    Merchandiser: Array.isArray(state.contacts.contactlistsearchresult) ? state.contacts.contactlistsearchresult : [],
    Warehouse: state.warehouse.warehouselist,
    Attribute: state.attribute.attributelist
  };
};

export default connect(mapStateToProps, {
  getAllCategory,
  getAllContactMerchandiser,
  getAllWarehouse,
  getOnlyWarehouse,
  createVariableProduct,
  getAllAttribute,
  getspecificSingleProductbyname,
})(CreateNewContact);
